import { render, staticRenderFns } from "./TreesAddBlock.vue?vue&type=template&id=4ecb7ad9&scoped=true&"
import script from "./TreesAddBlock.vue?vue&type=script&lang=js&"
export * from "./TreesAddBlock.vue?vue&type=script&lang=js&"
import style0 from "./TreesAddBlock.vue?vue&type=style&index=0&id=4ecb7ad9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecb7ad9",
  null
  
)

export default component.exports